import React, { useState } from 'react'
import ReactMapGL, { NavigationControl } from 'react-map-gl'
import { isNotNilOrEmpty } from '@soltalabs/ramda-extra'
import { connect } from '@soltalabs/stateless'
import { siteList$ } from 'modules/ravensdown/site'
import { MAP_BOX_ACCESS_TOKEN } from 'utils/env'
import { Pin } from './Pin'

import { styled, s } from 'lib/styled'

import 'react-map-gl-geocoder/dist/mapbox-gl-geocoder.css'

const Root = styled.div(s('flex-1 m-0'), {
  canvas: s('rounded-lg'),
})

const CameraControls = styled(NavigationControl)(s('absolute z-2'), {
  top: 10,
  right: 10,
})

const Connected = connect(() => ({
  siteList: siteList$,
}))(Map)

function Map({ siteList, onMapDblClick }) {
  const [viewport, setViewport] = useState({
    width: '100%',
    height: '100%',
    latitude: -42.168005,
    longitude: 173.163614,
    zoom: 5,
    offSetTop: -20,
  })
  const [selectedSite, setSelectedSite] = useState()

  function onViewportChange(updatedViewport) {
    setViewport({ ...viewport, ...updatedViewport })
  }

  return (
    <Root>
      <ReactMapGL
        {...viewport}
        mapStyle="mapbox://styles/mapbox/streets-v9"
        onViewportChange={onViewportChange}
        mapboxApiAccessToken={MAP_BOX_ACCESS_TOKEN}
        onDblClick={onMapDblClick}
      >
        <CameraControls />

        {isNotNilOrEmpty(siteList) &&
          siteList.map((site) => {
            const { id, siteName, assessments, addressLocation } = site

            return (
              <Pin
                key={id}
                isSelected={selectedSite === id}
                name={siteName}
                assessments={assessments}
                location={addressLocation}
                onClick={() => setSelectedSite(id)}
                onClosePopup={() => setSelectedSite(undefined)}
              />
            )
          })}
      </ReactMapGL>
    </Root>
  )
}

export { Connected as Map }
